import type { RequestParams } from '../requests/http-client';
import { ContentType, HttpClient } from '../requests/http-client';
import type {
  AddChannelEventFilterReq,
  BaseErrorResponse,
  Cs2ChannelVM,
  Cs2EventFilterChannelVM,
  EmptySuccessResponse,
  UpdateChannelEventFilterReq,
} from './data-contracts';


export default function useChannel() {
  class Channel<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
    /**
     * No description
     *
     * @tags Channel
     * @name ChannelControllerGetChannels
     * @summary Returns a list of channels
     * @request GET:/cs2/channel
     * @secure
     * @response `200` `(Cs2ChannelVM)[]`
     * @response `400` `BaseErrorResponse`
     */
    channelControllerGetChannels = (params: RequestParams = {}) =>
      this.request<Cs2ChannelVM[], BaseErrorResponse>({
        path: '/cs2/channel',
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Channel
     * @name ChannelEventFilterControllerAddEventFilter
     * @summary Creates channel event filter
     * @request POST:/cs2/channel/{channelId}/event-filter
     * @secure
     * @response `200` `Cs2EventFilterChannelVM`
     * @response `400` `BaseErrorResponse`
     */
    channelEventFilterControllerAddEventFilter = (
      channelId: number,
      data: AddChannelEventFilterReq,
      params: RequestParams = {},
    ) =>
      this.request<Cs2EventFilterChannelVM, BaseErrorResponse>({
        path: `/cs2/channel/${channelId}/event-filter`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Channel
     * @name ChannelEventFilterControllerUpdateEventFilter
     * @summary Updates channel event filter
     * @request PUT:/cs2/channel/{channelId}/event-filter/{eventFilterChannelId}
     * @secure
     * @response `200` `Cs2EventFilterChannelVM`
     * @response `400` `BaseErrorResponse`
     */
    channelEventFilterControllerUpdateEventFilter = (
      channelId: number,
      eventFilterChannelId: number,
      data: UpdateChannelEventFilterReq,
      params: RequestParams = {},
    ) =>
      this.request<Cs2EventFilterChannelVM, BaseErrorResponse>({
        path: `/cs2/channel/${channelId}/event-filter/${eventFilterChannelId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Channel
     * @name ChannelEventFilterControllerDeleteEventFilter
     * @summary Deletes channel event filter
     * @request DELETE:/cs2/channel/{channelId}/event-filter/{eventFilterChannelId}
     * @secure
     * @response `200` `EmptySuccessResponse`
     * @response `400` `BaseErrorResponse`
     */
    channelEventFilterControllerDeleteEventFilter = (
      channelId: number,
      eventFilterChannelId: number,
      params: RequestParams = {},
    ) =>
      this.request<EmptySuccessResponse, BaseErrorResponse>({
        path: `/cs2/channel/${channelId}/event-filter/${eventFilterChannelId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      });
  }

  return new Channel();
}
